var render = function () {
  var _vm$user, _vm$user2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.showFloatingButtons ? _c('div', {
    staticClass: "sticky-button-wrapper"
  }, [_vm.isBuyNowShow ? _c('div', {
    staticClass: "buy-now-btn btn btn-warning d-flex align-items-center justify-content-center",
    attrs: {
      "title": "Buy Now"
    },
    on: {
      "click": _vm.redirectToBuy
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "ShoppingCartIcon"
    }
  }), _c('span', {
    staticClass: "btn-text"
  }, [_vm._v("Buy Now")])], 1) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [!((_vm$user = _vm.user) !== null && _vm$user !== void 0 && _vm$user.super_admin) && (_vm$user2 = _vm.user) !== null && _vm$user2 !== void 0 && _vm$user2.admin && _vm.showChatButton ? _c('div', {
    staticClass: "chat-ai-btn btn btn-primary shadow",
    attrs: {
      "title": "Chat With AI"
    },
    on: {
      "click": _vm.toggleChatBot
    }
  }, [_c('feather-icon', {
    staticClass: "text-white chat-icon",
    attrs: {
      "icon": "CpuIcon"
    }
  })], 1) : _vm._e()])], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }